import { FormControl, InputLabel, Select, MenuItem, Autocomplete, TextField } from "@mui/material";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import dayjs from "dayjs";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  tipoPesquisa: number,
  pesquisa: string,
  setor: string,
  filial: string,
  admissaoDe: string,
  admissaoAte: string,
  demissaoDe: string,
  demissaoAte: string,
  afastamentoDe: string,
  afastamentoAte: string,
  feriasDe: string,
  feriasAte: string,
  treinamento: number,
  prazoExperiencia: number,
  documento: number,
  centroDeCusto: number[],
  status: number,
  centroDeCustoLista: { id: number, title: string }[],
  handleTipoPesquisa: (v: number) => void,
  handlePesquisa: (v: string) => void,
  handleSetor: (v: string) => void,
  handleFilial: (v: string) => void,
  handleAdmissao: (de: string, ate: string) => void,
  handleDemissao: (de: string, ate: string) => void,
  handleAfastamento: (de: string, ate: string) => void,
  handleFerias: (de: string, ate: string) => void,
  handleTreinamento: (v: number) => void,
  handlePrazoExperiencia: (v: number) => void,
  handleDocumento: (v: number) => void,
  handleCentroDeCusto: (v: number[]) => void,
  handleStatusSelection: (x: number) => void,
  handleClearFilters: () => void,
};

export const Header = ({
  tipoPesquisa,
  pesquisa,
  setor,
  filial,
  admissaoDe,
  admissaoAte,
  demissaoDe,
  demissaoAte,
  afastamentoDe,
  afastamentoAte,
  feriasDe,
  feriasAte,
  treinamento,
  prazoExperiencia,
  documento,
  centroDeCusto,
  status,
  centroDeCustoLista,
  handleTipoPesquisa,
  handlePesquisa,
  handleSetor,
  handleFilial,
  handleAdmissao,
  handleDemissao,
  handleAfastamento,
  handleFerias,
  handleTreinamento,
  handlePrazoExperiencia,
  handleDocumento,
  handleCentroDeCusto,
  handleStatusSelection,
  handleClearFilters,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">
            <div className="flex lg:col-span-2 md:col-span-2 gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={async (x) => {
                    handlePesquisa('');
                    handleTipoPesquisa(x.target.value as number)
                  }}>
                  <MenuItem value={0}>Nome</MenuItem>
                  <MenuItem value={1}>Cargo</MenuItem>
                  <MenuItem value={2}>Matrícula</MenuItem>
                  <MenuItem value={3}>Avaliação de Habilidades</MenuItem>
                  <MenuItem value={4}>Avaliação de Treinamentos</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                {
                  (tipoPesquisa === 0 || tipoPesquisa === 1 || tipoPesquisa === 2) &&
                  <DefaultInput
                    label="Pesquisar"
                    name="search_by_name"
                    value={pesquisa}
                    onChangeValue={handlePesquisa} />
                }
                {
                  (tipoPesquisa === 3) &&
                  <FormControl size="small" fullWidth>
                    <InputLabel id="treinamento" size="small">Pesquisar</InputLabel>
                    <Select
                      size="small"
                      labelId="pesquisar"
                      label="Pesquisar"
                      value={pesquisa}
                      onChange={async (x) => handlePesquisa(x.target.value)}>
                      <MenuItem value={'A'}>Em Atraso</MenuItem>
                      <MenuItem value={'D'}>Dentro do prazo</MenuItem>
                      <MenuItem value={'C'}>Concluídas</MenuItem>
                    </Select>
                  </FormControl>
                }
                {
                  (tipoPesquisa === 4) &&
                  <FormControl size="small" fullWidth>
                    <InputLabel id="treinamento" size="small">Pesquisar</InputLabel>
                    <Select
                      size="small"
                      labelId="pesquisar"
                      label="Pesquisar"
                      value={pesquisa}
                      onChange={async (x) => handlePesquisa(x.target.value)}>
                      <MenuItem value={'A'}>Em Atraso</MenuItem>
                      <MenuItem value={'D'}>Dentro do prazo</MenuItem>
                      <MenuItem value={'N'}>Não Realizados</MenuItem>
                      <MenuItem value={'C'}>Avaliados</MenuItem>
                    </Select>
                  </FormControl>
                }
              </div>
            </div>

            <DefaultInput
              label="Pesquisar por setor"
              name="search_by_sector"
              value={setor}
              onChangeValue={handleSetor} />

            <DefaultInput
              label="Pesquisar por filial"
              name="search_by_filial"
              value={filial}
              onChangeValue={handleFilial} />

            <DefaultDateRangePickerInput
              label='Admissão'
              dataDe={admissaoDe ? dayjs(admissaoDe).toDate() : null}
              dataAte={admissaoAte ? dayjs(admissaoAte).toDate() : null}
              onChange={(de, ate) => {
                handleAdmissao(
                  de ? de.toISOString() : '',
                  ate ? ate.toISOString() : '',
                )
              }}
            />

            <DefaultDateRangePickerInput
              label='Demissão'
              dataDe={demissaoDe ? dayjs(demissaoDe).toDate() : null}
              dataAte={demissaoAte ? dayjs(demissaoAte).toDate() : null}
              onChange={(de, ate) => {
                handleDemissao(
                  de ? de.toISOString() : '',
                  ate ? ate.toISOString() : '',
                )
              }}
            />

            <DefaultDateRangePickerInput
              label='Afastamento'
              dataDe={afastamentoDe ? dayjs(afastamentoDe).toDate() : null}
              dataAte={afastamentoAte ? dayjs(afastamentoAte).toDate() : null}
              onChange={(de, ate) => {
                handleAfastamento(
                  de ? de.toISOString() : '',
                  ate ? ate.toISOString() : '',
                )
              }}
            />

            <DefaultDateRangePickerInput
              label='Férias'
              dataDe={feriasDe ? dayjs(feriasDe).toDate() : null}
              dataAte={feriasAte ? dayjs(feriasAte).toDate() : null}
              onChange={(de, ate) => {
                handleFerias(
                  de ? de.toISOString() : '',
                  ate ? ate.toISOString() : '',
                )
              }}
            />

            <FormControl size="small">
              <InputLabel id="treinamento" size="small">Treinamentos</InputLabel>
              <Select
                size="small"
                labelId="treinamento"
                label="Treinamentos"
                value={treinamento}
                onChange={async (x) => handleTreinamento(x.target.value as number)}>
                <MenuItem value={0}>Todos</MenuItem>
                <MenuItem value={1}>Não realizados</MenuItem>
                <MenuItem value={2}>Realizados</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small">
              <InputLabel id="prazo-experiencia" size="small">Prazo de Experiência</InputLabel>
              <Select
                size="small"
                labelId="prazo-experiencia"
                label="Prazo de Experiência"
                value={prazoExperiencia}
                onChange={async (x) => handlePrazoExperiencia(x.target.value as number)}>
                <MenuItem value={0}>Todas</MenuItem>
                <MenuItem value={1}>Em andamento</MenuItem>
                <MenuItem value={2}>Vencidas</MenuItem>
                <MenuItem value={3}>Aprovadas</MenuItem>
                <MenuItem value={4}>Reprovadas</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" fullWidth>
              <Autocomplete
                size="small"
                multiple
                options={centroDeCustoLista}
                value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
                getOptionLabel={(i) => i.title}
                onChange={(_, newValue) => {
                  const selectedIds = newValue.map((i) => i.id);
                  handleCentroDeCusto(selectedIds);
                }}
                isOptionEqualToValue={(option, selectedOption) => option.id === selectedOption.id}
                getOptionKey={(x) => x.id}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Centro de custo"
                  />
                )}
              />
            </FormControl>

            <FormControl size="small" fullWidth>
              <InputLabel id="modulo-dashboard">Status</InputLabel>
              <Select
                labelId="modulo-dashboard"
                label="Status"
                value={status}
                onChange={async (x) => handleStatusSelection(x.target.value as number)}>
                <MenuItem value={0}>Todos os funcionário</MenuItem>
                <MenuItem value={1}>Ativos</MenuItem>
                <MenuItem value={2}>Demitidos</MenuItem>
                <MenuItem value={3}>Afastados</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small">
              <InputLabel id="documento" size="small">Documentos</InputLabel>
              <Select
                size="small"
                labelId="documento"
                label="Documentos"
                value={documento}
                onChange={async (x) => handleDocumento(x.target.value as number)}>
                <MenuItem value={0}>Todos</MenuItem>
                <MenuItem value={1}>Em dia</MenuItem>
                <MenuItem value={2}>Vencidos</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}